import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cast',
  standalone: true,
  pure: true,
})
export class TypeCastPipe implements PipeTransform {
  /**
   * Casts a values type to the type obtained from the input.
   * @param value S: Base type of value.
   * @returns T: Type obtained by attribute type.
   */
  // See also: https://stackoverflow.com/questions/65486599/error-ts2739-type-abstractcontrol-is-missing-the-following-properties-from-ty/69466380#69466380
  transform<S, T extends S>(value: S): T {
    return <T>value;
  }
}
